module.exports = __webpack_public_path__ + "img/pic-02.9dc3e091.png";